export default __webpack_public_path__ + "static/media/0151.1fdf82a8.jpg";